export function Datalist<T extends { id: string }>({ id, items, getTitle, getDescription }: { id: string; items: T[]; getTitle: (item: T) => string; getDescription: (item: T) => string }) {
  return items ? (
    <datalist id={id}>
      {items.map((item) => (
        <option value={getTitle(item)} label={getDescription(item)} key={item.id} />
      ))}
    </datalist>
  ) : null;
}
